import { useState, useEffect } from 'react'
import { ButtonFilled, ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { DatePicker, Modal, Select } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import toast from 'react-hot-toast';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { DeleteClassBookingService, DeletePersonalTrainingSubscriptionTeacherTimeTableService, GetPersonalTrainingSubscriptionTeacherTimeTableService } from '../../services/class_booking/classBookingServices';
import { GetTeacherSearchService } from '../../services/class_booking/TeacherServices';
import SettingsMenu from '../staticscreens/SettingsMenu';
import BatchBookingMenu from '../batch_booking/BatchBookingMenu';
import { CiStickyNote } from "react-icons/ci";

function BatchSubscriptionTimeTable() {

  const navigator = useNavigate()
  const {state} = useLocation()
  const {pathname}  = useLocation()
  
  const roles = useSelector(state=>state.Auth.roles)
  const user = useSelector(state=>state.Auth)
  const isTeacher = user?.logged_user_type === 'Teacher'

  const [modal, setmodal] = useState(false)
  const [page, setpage] = useState(1)
  const [data, setdata] = useState({})
  const [selecteddata, setselecteddata] = useState({})
  const [teachers, setteachers] = useState([])


  const [search, setsearch] = useState({ text: '',text1: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false, teacher:'' })

  useEffect(() => {
    getdata()
  }, [page])

  async function getdata() {
    const response = await GetPersonalTrainingSubscriptionTeacherTimeTableService({ page, from_date: search?.from_date1, to_date: search?.to_date1, personal_training_subscription_teacher_batch: state?._id });
    setdata(response?.data)
  }


  async function applyFilter() {
    setsearch({ ...search, activate: true })
    setpage(1)
    const response = await GetPersonalTrainingSubscriptionTeacherTimeTableService({ page: 1, from_date: search?.from_date1, to_date: search?.to_date1, personal_training_subscription_teacher_batch: state?._id })
    setdata(response?.data)
  }

  async function resetfilter() {
    setsearch({ text: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false,text1:'',teacher:'' })
    setpage(1)
    const response = await GetPersonalTrainingSubscriptionTeacherTimeTableService({ page: 1, from_date: '', to_date: '', personal_training_subscription_teacher_batch: state?._id })
    setdata(response?.data)
  }

  const formatTo12Hour = (time) => {
    if (!time) return "";

    const [hours, minutes] = time.split(":");
    let h = parseInt(hours, 10);
    const ampm = h >= 12 ? "PM" : "AM";

    h = h % 12 || 12; // convert 0 -> 12
    return `${h}:${minutes} ${ampm}`;
  };


  async function deleteData() {
    const response = await DeletePersonalTrainingSubscriptionTeacherTimeTableService(selecteddata?._id)
    if (response?.status === 200) {
      toast.success("Deleted Successfully")
    } else {
      toast.success("Deleted Successfully")
    }
    setmodal(false)
    getdata()
  }

  console.log("data",data)

  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>

      <Modal
        keepMounted
        open={modal}
        onClose={() => setmodal(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmodal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Confirm'} onClick={() => deleteData()} />
            </div>
          </div>
        </div>
      </Modal>

      <div className='md:flex'>
        <div>
          {pathname === '/batches_booking/list/time_table' ? <BatchBookingMenu state={state} /> : <SettingsMenu />}
        </div>
        <div className='md:w-[90%] pl-5 mt-4'>

          <div className='md:flex items-center -mt-1 border-b justify-between pb-1'>
            <div className='flex items-center justify-between'>
            <h6 className='font-[800] text-[13px]'>Total Batch Time Table ({data?.pagination?.total})</h6>
            <div className='flex md:hidden items-center text-[12px]'>
              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
            </div>
            </div>

            <div className='flex flex-wrap items-center text-[12px]'>

              <div className='hidden md:flex items-center'>

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>

              <DatePicker  size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

              <DatePicker  size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />

              </div>

              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={() => resetfilter()} />
              </div>

              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonFilledAutoWidth btnName="Add New" onClick={() => navigator('create',{state:{main_data:state}})} />
              </div>
            </div>
          </div>

          <div className='md:h-[90vh] mb-[50px] md:overflow-hidden'>

            {data?.datas?.length === 0 &&
              <div className='grid place-items-center mt-20  items-center justify-center'>
                <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
                <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
              </div>}

            <div className='w-[100%] overflow-hidden'>
              {data?.datas?.length > 0 &&
                <>
                {/* Desktop / tablet table */}
                <div className='hidden md:block md:max-h-[85vh] mt-4 md:overflow-auto border-t border-l border-r'>
                  <div className='sticky top-0 z-50 flex w-full  bg-white py-[-5px] border-b border-slate-200 relative'>
                    <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px] px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Date </h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Student List</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Batch / Class</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[200px] w-[200px]  px-2 py-1 font-[600] text-slate-800 border-r'>Topic Covering / Remarks</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[146px] w-[146px]  px-2 py-1 font-[600] text-slate-800 border-r'>Class Status</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800 border-r'>Created At</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800'>Action</h6>
                  </div>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='flex w-full text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                      <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[500] border-r flex items-start justify-center'>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>

                      <h6 className=' text-[12px] break-word min-w-[160px] w-[160px]  px-2 py-1 font-[500] border-r'>
                        <span className='font-bold'>{moment(d?.date)?.format('LL')}</span><br></br>
                      </h6>
                      <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  px-2 py-1 font-[500] border-r'>
                       <h6 className='text-[11px]'>Total Users : {d?.students?.length}</h6>
                       <div className='flex flex-wrap '>
                       {d?.students?.map((s)=><span className='bg-slate-200 text-[11px] p-[4px] m-[4px]'>{s?.name}{!isTeacher && ` - [${s?.mobile}]`}</span>)}
                       </div>
                      </h6>
                      <h6 className=' text-[11px] break-word min-w-[180px] w-[180px]  px-2 py-1  border-r'>
                        {formatTo12Hour(d?.batch?.start_time)} - {formatTo12Hour(d?.batch?.end_time)} <br></br>
                        {d?.class?.label}
                      </h6>
                      <h6 className='flex break-word  min-w-[200px] w-[200px]  px-2 py-1 font-[500] border-r'> Topic Covering : {d?.topics_covering} <br></br>Remarks : {d?.remarks}</h6>
                      <h6 className='flex break-word  min-w-[146px] w-[146px]  px-2 py-1 break-all capitalize font-[500] border-r'>{d?.class_status}</h6>
                      <h6 className='  break-word min-w-[120px] w-[120px]  px-2 py-1 font-[500] border-r'>{moment(d?.createdAt)?.format('LL')}</h6>
                      <h6 className='text-[12px] flex items-start min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800'>
                        { <AiOutlineEdit onClick={() => navigator('edit', { state: {main_data: state, data: d} })} className='mr-2' />}
                        {d?.class_status === 'completed' && <CiStickyNote onClick={() => navigator('student_summary', { state: d })} className='mr-2' />}
                         {roles?.includes('admin') &&  <AiOutlineDelete onClick={() => {setselecteddata(d);setmodal(true)}} className='mr-2' />}
                      </h6>
                    </div>))}
                </div>

                {/* Mobile card list */}
                <div className='md:hidden mt-3 space-y-2'>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='border rounded-md p-3 bg-white'>
                      <div className='flex items-start justify-between'>
                        <div>
                          <h6 className='text-[13px] font-[700]'>{moment(d?.date)?.format('LL')}</h6>
                          <h6 className='text-[10px] w-max capitalize bg-slate-100 px-1.5 py-0.5 rounded mt-1'>{d?.class_status}</h6>
                        </div>
                        <div className='flex items-center -mr-1.5'>
                          <span className='p-2 cursor-pointer'><AiOutlineEdit size={17} onClick={() => navigator('edit', { state: {main_data: state, data: d} })} /></span>
                          {d?.class_status === 'completed' && <span className='p-2 cursor-pointer'><CiStickyNote size={17} onClick={() => navigator('student_summary', { state: d })} /></span>}
                          {roles?.includes('admin') && <span className='p-2 cursor-pointer'><AiOutlineDelete size={17} onClick={() => {setselecteddata(d);setmodal(true)}} /></span>}
                        </div>
                      </div>

                      <h6 className='text-[11px] text-slate-600 mt-2'>{formatTo12Hour(d?.batch?.start_time)} - {formatTo12Hour(d?.batch?.end_time)} {d?.class?.label && `· ${d?.class?.label}`}</h6>

                      <h6 className='text-[11px] mt-2 font-[600]'>Students ({d?.students?.length || 0})</h6>
                      <div className='flex flex-wrap'>
                        {d?.students?.map((s)=><span key={s?._id} className='bg-slate-100 text-[11px] px-1.5 py-1 rounded m-[3px]'>{s?.name}{!isTeacher && ` - [${s?.mobile}]`}</span>)}
                      </div>

                      {d?.topics_covering && <h6 className='text-[11px] mt-2'><span className='font-[600]'>Topics:</span> {d?.topics_covering}</h6>}
                      {d?.remarks && <h6 className='text-[11px] mt-1'><span className='font-[600]'>Remarks:</span> {d?.remarks}</h6>}

                      <h6 className='text-[10px] text-slate-400 mt-2'>Created {moment(d?.createdAt)?.format('LL')}</h6>
                    </div>
                  ))}
                </div>
                </>}
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default BatchSubscriptionTimeTable